import type { FetchOptions } from 'ofetch'
import type { AnyApiSpec } from '@st/openapi-tools'
import { createTypedExtendedFetch } from '@st/openapi-tools'

export function useCreateRawFetch<ApiSchema extends AnyApiSpec>(
  useApiConfig: () => {
    createApiConfig: (options?: FetchOptions) => FetchOptions
  },
) {
  const { createApiConfig } = useApiConfig()
  return createTypedExtendedFetch<ApiSchema>(createApiConfig())
}
